import React from 'react'
import {ProfilePage} from "./ProfilePage";
import {FormikProvider, useFormik} from "formik";
import {changePasswordSchema} from "../../../schema/authSchema";
import {changePassword} from "../../../services/authSvc";
import {useNotification} from "../../../context/NotificationContext";

export const ProfileSecurityTab = () => {
  const {showNotification} = useNotification()

  const formik = useFormik({
    initialValues: {
      old_password: '',
      new_password: '',
      new_password_confirm: ''
    },
    validationSchema: changePasswordSchema,
    onSubmit: async (values) => {
          try {
            const res = await changePassword(values)
            if (res.success) {
              showNotification('Muvaffaqiyatli', "Parol almashtirildi", "success")
            }
          } catch (e: any) {
            const errorMessage = e.response?.data?.message || e.data?.data?.data?.detail || 'Kutilmagan xatolik'
            showNotification('Xatolik', errorMessage, "error")
          }
      }
  })

  return (
      <ProfilePage>
        <div className="card mb-5 mb-xl-10">
          <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse"
               data-bs-target="#kt_account_profile_details" aria-expanded="true"
               aria-controls="kt_account_profile_details">
            <div className="card-title m-0"><h3 className="fw-bolder m-0">Parol almashtirish</h3></div>
          </div>
          <div id="kt_account_profile_details" className="collapse show">
            <FormikProvider value={formik}>
              <form onSubmit={formik.handleSubmit} className="form">
                <div className="card-body border-top p-9">
                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">Hozirgi parol</label>
                    <div className="col-lg-8 fv-row">
                      <input type="text"
                                       onChange={
                                         (e)=>{
                                           formik.setFieldValue('old_password', e.target.value)
                                         }
                                       }
                                       value={formik.values.old_password}
                                       onBlur={formik.handleBlur}
                                       className={`form-control form-control-lg form-control-solid ${formik.touched.old_password && formik.errors.old_password ? 'is-invalid' : ''}`}
                                       placeholder="Hozirgi parol" name="old_password"
                      />
                      {formik.touched.old_password && formik.errors.old_password ? (
                          <div className="invalid-feedback">{formik.errors.old_password}</div>
                      ) : null}
                    </div>
                  </div>

                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">Yangi parol</label>
                    <div className="col-lg-8 fv-row">
                      <input type="text"
                                       onChange={
                                         (e)=>{
                                           formik.setFieldValue('new_password', e.target.value)
                                         }
                                       }
                                       value={formik.values.new_password}
                                       onBlur={formik.handleBlur}
                                       className={`form-control form-control-lg form-control-solid ${formik.touched.new_password && formik.errors.new_password ? 'is-invalid' : ''}`}
                                       placeholder="Yangi parol" name="new_password"
                      />
                      {formik.touched.new_password && formik.errors.new_password ? (
                          <div className="invalid-feedback">{formik.errors.new_password}</div>
                      ) : null}
                    </div>
                  </div>

                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">Yangi parol qaytadan</label>
                    <div className="col-lg-8 fv-row">
                      <input type="text"
                                       onChange={
                                         (e)=>{
                                           formik.setFieldValue('new_password_confirm', e.target.value)
                                         }
                                       }
                                       value={formik.values.new_password_confirm}
                                       onBlur={formik.handleBlur}
                                       className={`form-control form-control-lg form-control-solid ${formik.touched.new_password_confirm && formik.errors.new_password_confirm ? 'is-invalid' : ''}`}
                                       placeholder="Yangi parol qaytadan" name="new_password_confirm"
                      />
                      {formik.touched.new_password_confirm && formik.errors.new_password_confirm ? (
                          <div className="invalid-feedback">{formik.errors.new_password_confirm}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="card-footer d-flex justify-content-end py-6 px-9">
                  <button disabled={formik.isSubmitting ||
                  !formik.isValid || !formik.dirty
                  } type="submit" className="btn btn-primary">{
                    formik.isSubmitting ? 'Yangilanmoqda...' : 'Yangilash'
                  }</button>
                </div>
              </form>
            </FormikProvider>
          </div>
        </div>
      </ProfilePage>
  )
}